module.exports = __webpack_public_path__ + "img/58_5.e7cd7188.png";